import { ContactPhoneContainer } from '../../containers/advancedFilters/ContactPhoneContainer';
import { IFilter } from '../../types/advancedFilters';

export const contact: IFilter = {
  component: ContactPhoneContainer,
};
